import React from "react";
import { CloseIcon } from "../SvgIcon";
import moment from "moment-timezone";

const NotificationLogDetails = ({ onClose, notificationDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "Sent":
        return "#28a745";
      case "Delivered":
        return "#28a745";
      case "Failed":
        return "#dc3545";
      case "Abandoned":
        return "#ffc107";
      case "Queued":
        return "#0dcaf0";
      default:
        return "#6c757d";
    }
  };

  const getChannelIcon = (channel) => {
    switch (channel) {
      case "Email":
        return "📧";
      case "Push":
        return "🔔";
      case "SMS":
        return "💬";
      default:
        return "📬";
    }
  };

  const getChannelColor = (channel) => {
    switch (channel) {
      case "Email":
        return "#5b7ce6";
      case "Push":
        return "#b39ddb";
      case "SMS":
        return "#81c784";
      default:
        return "#999";
    }
  };

  // Sample delivery timeline
  const deliveryTimeline = [
    {
      event: "Notification Created",
      timestamp: notificationDetails?.triggeredAt || "-",
    },
    {
      event: `Handed to ${notificationDetails?.provider || "SendGrid"} API`,
      timestamp: notificationDetails?.triggeredAt || "-",
    },
    {
      event: `Final Status: ${notificationDetails?.status?.toLowerCase() || "sent"}`,
      timestamp: notificationDetails?.triggeredAt || "-",
    },
  ];

  return (
    <div className="right-modal notification-log-details-modal">
      {/* Modal Header */}
      <div className="modal-header">
        <div className="modal-title">
          <h2 className="font-semibold">Notification Log Details</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        {/* Message Dispatch Info */}
        <div className="modal-card mb-24">
          <div className="px-24 py-20">
            <h3 className="fw-semibold mb-0 text-uppercase text-gray-600">
              Message Dispatch Info
            </h3>
          </div>

          <div className="p-24 pt-0">
            {/* Status and Channel */}
            <div className="row mb-20">
              <div className="col-6">
                <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                  Status
                </label>
                <div className="status-indicator">
                  <span
                    className={`status-dot status-${notificationDetails?.status?.toLowerCase() || "default"}`}
                  ></span>
                  <span className="status-text text-success">
                    {notificationDetails?.status || "-"}
                  </span>
                </div>
              </div>
              <div className="col-6">
                <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                  Channel Id
                </label>
                <div className="channel-indicator">
                  <span className="channel-icon">
                    {notificationDetails?.channelId}
                  </span>
                  <span
                    className={`channel-text ${notificationDetails?.channel?.toLowerCase()}-channel`}
                  >
                    {notificationDetails?.channel || "-"}
                  </span>
                </div>
              </div>
            </div>

            {/* Activity Key */}
            <div className="mb-20">
              <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                Activity Key
              </label>
              <span className="activity-key-label">coupon.unused_reminder</span>
            </div>

            {/* Recipient */}
            <div className="mb-20">
              <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                Recipient
              </label>
              <span className="info-text">
                {notificationDetails?.recipient || "-"}
              </span>
            </div>

            {/* Provider and Message ID */}
            <div className="row mb-20">
              <div className="col-6">
                <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                  Provider
                </label>
                <span className="info-text fw-semibold">
                  {notificationDetails?.provider || "-"}
                </span>
              </div>
              <div className="col-6">
                <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                  Message ID
                </label>
                <span className="info-text-light">
                  {notificationDetails?.providerMessageId || "-"}
                </span>
              </div>
            </div>
            {/* Triggered At and Delivered At */}
            <div className="row">
              <div className="col-6">
                <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                  Triggered At
                </label>
                <div className="time-info">
                  <span className="time-icon">🕐</span>
                  <span className="time-text">
                    {notificationDetails?.triggeredAt || "-"}
                  </span>
                </div>
              </div>
              <div className="col-6">
                <label className="text-xs text-gray-500 fw-semibold mb-8 d-block">
                  Updated At
                </label>
                <div className="time-info">
                  <span className="time-icon">🕐</span>
                  <span className="time-text">
                    {moment(notificationDetails?._original?.updatedAt).format(
                      "DD MMM YYYY, HH:mm",
                    ) || "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Delivery Timeline */}
        <div className="modal-card mb-0">
          <div className="px-24 py-20">
            <h3 className="fw-semibold mb-0 text-uppercase text-gray-600">
              Delivery Timeline
            </h3>
          </div>

          <div className="p-24 pt-0">
            <div className="delivery-timeline">
              {deliveryTimeline?.map(
                (item, index) => (
                  <div key={index} className="timeline-item">
                    {/* Timeline dot */}
                    <div className="timeline-dot"></div>

                    {/* Timeline line */}
                    {index < deliveryTimeline.length - 1 && (
                      <div className="timeline-line"></div>
                    )}

                    {/* Event content */}
                    <div className="timeline-content">
                      <h4>{item.event}</h4>
                      <p>{item.timestamp}</p>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="modal-footer">
        <button className="btn-outline-light" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default NotificationLogDetails;
